export default __webpack_public_path__ + "static/media/reminder.1ac8647b.svg";